import { styled } from 'goober';
import { forwardRef } from 'react';
var borderRadius = '4px';
export var FormField = styled('div')(function (_a) {
    var theme = _a.theme, $bottomSpace = _a.$bottomSpace;
    return ({
        flexBasis: 0,
        flexGrow: 1,
        marginBottom: $bottomSpace ? theme.space.m : '0px',
    });
});
export var FormFieldForSelect = styled('div')(function (_a) {
    var theme = _a.theme, $bottomSpace = _a.$bottomSpace, $small = _a.$small;
    return ({
        marginBottom: $bottomSpace ? theme.space.m : '0px',
        '.fs-select': {
            zIndex: 1000,
            minHeight: '24px',
            height: $small ? '24pxx' : '32px',
            border: "1px solid ".concat(theme.colors.neutral.w100),
            borderRadius: borderRadius,
            backgroundColor: theme.colors.neutral.w50,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            '&:hover': {
                backgroundColor: theme.colors.neutral.w100,
                borderColor: theme.colors.neutral.w200,
            },
            '&:focus-within': {
                borderColor: theme.colors.primary.w500,
            },
        },
        '.fs-select.invalid': {
            borderColor: theme.colors.error.w500,
        },
        '.fs-select__control': {
            border: 0,
            boxShadow: 'none',
            minHeight: '24px',
            height: $small ? '24pxx' : '32px',
            fontSize: $small ? '11px' : '12px',
            backgroundColor: 'transparent',
            color: theme.colors.ui.dark,
            padding: '0px 10px',
            flexGrow: 1,
        },
        '.fs-select__indicator-separator': {
            display: 'none',
        },
        '.fs-select__dropdown-indicator': {
            padding: '0px',
        },
        '.fs-select__control__indicators': {
            color: theme.colors.ui.dark,
            width: '25px',
            padding: '0px 5px',
        },
        '.fs-select__control__indicators svg': {
            color: theme.colors.ui.dark,
        },
        '.fs-select__value-container': {
            padding: 0,
        },
        '.fs-select__single-value': {
            color: theme.colors.ui.dark,
        },
        'input::placeholder': {
            color: theme.colors.neutral.w700,
        },
    });
});
export var FormFieldLabel = styled('p')(function (_a) {
    var theme = _a.theme, $bottomSpace = _a.$bottomSpace, $small = _a.$small;
    return ({
        color: theme.colors.ui.dark,
        fontSize: $small ? theme.font.formSizeSmall : theme.font.formSize,
        lineHeight: 1.5,
        marginBottom: $bottomSpace ? theme.space.m : '0px',
    });
});
export var FormFieldErrorHelp = styled('p')(function (_a) {
    var theme = _a.theme, $center = _a.$center, $small = _a.$small;
    return ({
        color: theme.colors.error.w500,
        fontSize: $small ? theme.font.formSizeSmall : theme.font.formSize,
        textAlign: $center ? 'center' : 'left',
        lineHeight: 1.5,
        margin: '0px',
    });
});
export var FormTextInput = styled('input')(function (_a) {
    var theme = _a.theme, $invalid = _a.$invalid, $small = _a.$small;
    return ({
        backgroundColor: theme.colors.neutral.w50,
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: $invalid ? theme.colors.error.w500 : theme.colors.neutral.w100,
        color: theme.colors.ui.dark,
        cursor: 'text',
        fontSize: $small ? theme.font.formSizeSmall : theme.font.formSize,
        minHeight: $small ? '24px' : '32px',
        borderRadius: borderRadius,
        padding: '5px 10px',
        width: '100%',
        fontFamily: 'Inter, sans-serif',
        outline: 'none',
        '&::placeholder': {
            color: theme.colors.neutral.w700,
        },
        '&:hover': {
            backgroundColor: theme.colors.neutral.w100,
            borderColor: $invalid ? theme.colors.error.w500 : theme.colors.neutral.w200,
        },
        '&:focus': {
            borderColor: $invalid ? theme.colors.error.w500 : theme.colors.primary.w500,
        },
        '&:disabled': {
            backgroundColor: theme.colors.neutral.w200,
            borderColor: theme.colors.neutral.w300,
            color: theme.colors.neutral.w700,
            cursor: 'not-allowed',
        },
    });
});
export var FormTextArea = styled('textarea')(function (_a) {
    var theme = _a.theme, $invalid = _a.$invalid, $small = _a.$small;
    return ({
        backgroundColor: theme.colors.neutral.w50,
        color: theme.colors.ui.dark,
        fontSize: $small ? theme.font.formSizeSmall : theme.font.formSize,
        borderRadius: borderRadius,
        padding: '8.5px 10px',
        width: '100%',
        display: 'block',
        border: "1px solid ".concat($invalid ? theme.colors.error.w500 : theme.colors.neutral.w100),
        outline: 'none',
        '&::placeholder': {
            color: theme.colors.neutral.w700,
        },
        '&:hover': {
            backgroundColor: theme.colors.neutral.w100,
            borderColor: $invalid ? theme.colors.error.w500 : theme.colors.neutral.w200,
        },
        '&:focus': {
            borderColor: $invalid ? theme.colors.error.w500 : theme.colors.primary.w500,
        },
        '&:disabled': {
            backgroundColor: theme.colors.neutral.w200,
            borderColor: theme.colors.neutral.w300,
            color: theme.colors.neutral.w700,
            cursor: 'not-allowed',
        },
    });
});
export var FormInputWithBtn = styled('div')(function (_a) {
    var theme = _a.theme, $invalid = _a.$invalid, $iconOnTheRight = _a.$iconOnTheRight, $small = _a.$small, $disabled = _a.$disabled, _b = _a.$cursor, $cursor = _b === void 0 ? 'text' : _b;
    return ({
        display: 'flex',
        alignItems: 'center',
        backgroundColor: $disabled ? theme.colors.neutral.w200 : theme.colors.neutral.w50,
        fontSize: $small ? theme.font.formSizeSmall : theme.font.formSize,
        color: $disabled ? theme.colors.neutral.w700 : theme.colors.ui.dark,
        cursor: $disabled ? 'not-allowed' : $cursor,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: $disabled ? theme.colors.neutral.w300 : $invalid ? theme.colors.error.w500 : theme.colors.neutral.w100,
        paddingLeft: $iconOnTheRight ? '0px' : '10px',
        paddingRight: $iconOnTheRight ? '10px' : '0px',
        '&:hover': {
            backgroundColor: $disabled ? theme.colors.neutral.w200 : theme.colors.neutral.w100,
            borderColor: $disabled
                ? theme.colors.neutral.w300
                : $invalid
                    ? theme.colors.error.w500
                    : theme.colors.neutral.w200,
        },
        '&:focus-within': {
            borderColor: $disabled
                ? theme.colors.neutral.w300
                : $invalid
                    ? theme.colors.error.w500
                    : theme.colors.primary.w500,
        },
        input: {
            outline: 'none',
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            color: 'inherit',
            cursor: 'inherit',
            pointerEvents: $disabled ? 'none' : 'all',
            '&:hover': {
                backgroundColor: 'transparent',
                borderColor: 'transparent',
            },
            '&:focus': {
                borderColor: 'transparent',
            },
            '&:disabled': {
                color: 'inherit',
                cursor: 'inherit',
                backgroundColor: 'transparent',
                borderColor: 'transparent',
            },
        },
        span: {
            paddingTop: '5px',
        },
        div: {
            // used for datepicker
            color: theme.colors.ui.dark,
            cursor: $disabled ? 'not-allowed' : $cursor,
            fontSize: $small ? theme.font.formSizeSmall : theme.font.formSize,
            minHeight: $small ? '24px' : '32px',
            padding: '5px 10px',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
        },
    });
});
export var FormCheckBox = styled('div')(function (_a) {
    var theme = _a.theme, _b = _a.$disabled, $disabled = _b === void 0 ? false : _b;
    return ({
        cursor: $disabled ? 'not-allowed' : 'pointer',
        opacity: $disabled ? 0.5 : 1,
        display: 'flex',
        alignItems: 'center',
        fontSize: theme.font.size,
        '-webkit-touch-callout': 'none',
        '-webkit-user-select': 'none',
        '-khtml-user-select': 'none',
        '-moz-user-select': 'none',
        '-ms-user-select': 'none',
        'user-select': 'none',
        maxWidth: '100%',
        svg: {
            flexShrink: 0,
            marginLeft: '-10px',
        },
    });
});
export var FormRadioInputBox = styled('div')(function (_a) {
    var theme = _a.theme, _b = _a.$disabled, $disabled = _b === void 0 ? false : _b;
    return ({
        cursor: $disabled ? 'not-allowed' : 'pointer',
        opacity: $disabled ? 0.5 : 1,
        display: 'flex',
        alignItems: 'center',
        fontSize: theme.font.size,
        '-webkit-touch-callout': 'none',
        '-webkit-user-select': 'none',
        '-khtml-user-select': 'none',
        '-moz-user-select': 'none',
        '-ms-user-select': 'none',
        'user-select': 'none',
        maxWidth: '100%',
        minHeight: '32px',
        svg: {
            flexShrink: 0,
            marginLeft: '-10px',
        },
        input: {
            margin: 0,
            marginBottom: '2px',
        },
        p: {
            paddingLeft: '5px',
            paddingRight: '10px',
        },
    });
});
export var FormCheckBoxLabel = styled('p')(function (_a) {
    var theme = _a.theme, $bottomSpace = _a.$bottomSpace, $small = _a.$small;
    return ({
        color: theme.colors.ui.dark,
        fontSize: $small ? theme.font.formSizeSmall : theme.font.formSize,
        lineHeight: 1.2,
        marginBottom: $bottomSpace ? theme.space.m : '0px',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    });
});
export var ColorPicker = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme, $currColor = _a.$currColor;
    return ({
        height: '28px',
        width: '28px',
        border: "1px solid ".concat(theme.borderColor),
        borderRadius: theme.borderRadius,
        backgroundColor: $currColor ? $currColor : 'transparent',
    });
});
export var MiniSelectWrap = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: '130px',
        marginRight: '5px',
        outline: 'none',
        '.fs-select__control': {
            borderColor: theme.borderColor,
            backgroundColor: '#fff',
            minHeight: '23px',
        },
        '.fs-select__control:hover': {
            borderColor: theme.borderColor,
        },
        '.fs-select__indicator-separator': {
            display: 'none',
        },
    });
});
